import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';


export interface PatientBookletParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface PatientbookletMst {

    id?: any; 
    
    issue_Date:Date;
    booklet_Name:string;
    employeeId:any;

    obstericsId:any;
    visitId:any;
    regId: string;    
    tenantId: any;
    branchId: any;
  createdDate?:Date;
    updatedDate?:Date;
    createdBy?:number;
    updatedBy?:number;
    createdIP?:string;
    updatedIP?:string;
    parameters?: PatientBookletParameter[];
    links?: any;
}

export abstract class PatientbookletData { 

    abstract list(url: string): Observable<PatientbookletMst[]>;
    abstract create(url: string, data: PatientbookletMst): Observable<any>;
    abstract update(url: string, data: PatientbookletMst): Observable<any>;
    abstract delete(url: string): Observable<any>;    
}
